import { Box, CircularProgress, Typography } from "@mui/material";
import { useJwtAuthInitialization } from "@/features/login/hooks/useJwtAuthInitialization";

/**
 * JWT認証コールバックページ
 * 外部サイトからのJWT認証後、URLパラメータで渡された認可コードを使って
 * トークン交換APIからアクセストークンとリフレッシュトークンを取得し、
 * ユーザー情報と地図契約情報を取得してログイン状態を確立する
 */
export const JwtCallback: React.FC = () => {
  const { isInitializing } = useJwtAuthInitialization();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 3,
      }}
    >
      {isInitializing ? (
        <>
          <CircularProgress size={60} />
          <Typography variant="h6" color="text.secondary">
            認証情報を取得しています...
          </Typography>
        </>
      ) : null}
    </Box>
  );
};
